import React from "react";
import { Icon } from "@iconify/react";
import closeIcon from "@iconify/icons-mdi/close";

import { Typography } from "@mui/material";

import '../../../styles/Auth/categoryPopup.css';

const ViewServiceSubCategoryPopup = ({ data, onClose }) => {
    const subcategory = data?.existingServiceSubCategory || data;

    return (
        <div className="category-detail-overlay">
            <div className="category-detail-modal">
                <button className="category-detail-close" onClick={onClose}>
                    <Icon icon="solar:close-circle-bold-duotone" width={32} height={32} />
                </button>

                <div className="category-detail-header">
                    <div className="category-detail-image-container">
                        <img
                            src={subcategory?.serviceSubCategoryImageObject?.uri ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${subcategory.serviceSubCategoryImageObject.uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"}
                            alt={subcategory.serviceSubCategoryName}
                            onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                            className="category-detail-img"
                        />
                    </div>
                    <Typography variant="h5" className="category-detail-title">
                        {subcategory.serviceSubCategoryName}
                    </Typography>
                </div>

                <div className="category-detail-content">
                    <div className="category-detail-stats">
                        <div className="stat-card">
                            <Icon icon="solar:branching-paths-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Service Category</span>
                                <span className="stat-value">{subcategory.serviceCategoryId?.serviceCategoryName || "N/A"}</span>
                            </div>
                        </div>
                    </div>

                    {subcategory.description && (
                        <div className="category-detail-section">
                            <label><Icon icon="solar:document-text-bold-duotone" /> Description</label>
                            <p>{subcategory.description}</p>
                        </div>
                    )}

                    <div className="category-detail-stats">
                        <div className="stat-card">
                            <Icon icon="solar:shop-2-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Status</span>
                                <span className={`stat-value ${subcategory.isActive ? 'active' : 'inactive'}`}>
                                    {subcategory.isActive ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="category-detail-footer">
                    <button className="category-detail-action-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewServiceSubCategoryPopup;
